const scope = "issueCounts";
export default scope;
